/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_Download_AuditInputs */

const cs_tasks_protocol_download_audit = /** @type {(inputs: Tasks_Protocol_Download_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stáhnout kontrolní list`)
};

const en_tasks_protocol_download_audit = /** @type {(inputs: Tasks_Protocol_Download_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download audit trail`)
};

/**
* | output |
* | --- |
* | "Download audit trail" |
*
* @param {Tasks_Protocol_Download_AuditInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_download_audit = /** @type {((inputs?: Tasks_Protocol_Download_AuditInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_Download_AuditInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_download_audit(inputs)
	return cs_tasks_protocol_download_audit(inputs)
});